import React from 'react';
import moment from 'moment';

import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, Select, Icon } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { LOGISTICA_PRODUCTOS_CON_LOTE } from '../../../../common/types/parametroType'
import global from '../../../../common/utility/global';
import auth from '../../../../common/utility/auth';
const { Option } = Select;

export default function Productos(props) {


    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 120,
                        render: (value, row) => {
                            return (
                                <div
                                    onClick={() => props.onEditarNombreProducto(row, props.onSetFieldsValue, props.onGetFieldValue)}

                                >
                                    {props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrNombre[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'idUnidadMedida',
                        key: 'idUnidadMedida',
                        width: 120,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridUnidadMedida[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Unidad de Medida"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row, "arridUnidadMedida", option.key, 0); }}
                                        >
                                            {props.unidadesMedida.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Afecto IGV',
                        dataIndex: 'flagAfecto',
                        key: 'flagAfecto',
                        align: 'center',
                        width: 60,
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagAfecto[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        <Checkbox
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            onChange={(e) => props.onCalculateDetail(row, "arrFlagAfecto", e.target.checked, 0)}>
                                        </Checkbox>
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Exonerado',
                        dataIndex: 'flagExonerado',
                        key: 'flagExonerado',
                        align: 'center',
                        width: 80,
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagExonerado[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        <Checkbox
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            onChange={(e) => props.onCalculateDetail(row, "arrFlagExonerado", e.target.checked, 0)}>
                                        </Checkbox>
                                    )}
                                </div>
                            );
                        }
                    },

                    {
                        title: 'Valor Unitario',
                        dataIndex: 'precioUnitarioSinIGV',
                        key: 'precioUnitarioSinIGV',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="V. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Precio Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecio[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="P. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecio", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(3),
                                        rules: [
                                            {
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato (0.00)"
                                            },
                                            {
                                                required: true,
                                                pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: ""
                                            }
                                        ]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 3)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Total Detalle',
                        dataIndex: 'totalDetalle',
                        key: 'totalDetalle',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrTotalDetalle[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        fixed: 'right',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={true}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrTotal", e.target.value, 2)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                ]}
            >
            </Table>
        </div >
    );
}